import { useEffect } from 'react';
import Layout from '../../../components/layout/Layout';
import Breadcrumb from '../../../components/layout/Breadcrumb';
import { updateSEO } from '../../../utils/seo';

// ===== Master Butler 詳細ページ 全面最新化（Implementer B スコープ） =====
// デザイン土台（型正典）: src/pages/about/overview/page.tsx / src/pages/home/page.tsx（紺#1a2942 / 真鍮金#a38e65 /
//   金差し色#d7b779 / BTN-08 2状態 / 金eyebrow→金差し色見出し→真鍮短罫 / リード3行+ / 装飾ディバイダー禁止）。
// 事実正典（創作禁止・実データ変更禁止・出典path記録）:
//   [S-cur] 旧 src/pages/qualifications/master-butler/page.tsx（全15章・料金128,000円・試験要項の実データ）
//   [S-canon] mng-thebutler/00_事業説明.md L63,L78（三段階資格 / House Steward 統括型）
//   [S-overview] src/pages/about/overview/page.tsx（BTN08・セクション文法）

const BTN08_ON_NAVY = "relative inline-flex items-center justify-center bg-[#a38e65] text-white font-semibold border border-[#1a2942] px-[42px] py-[16px] text-sm tracking-[0.2em] font-['Noto_Serif_JP',serif] transition-colors duration-300 hover:bg-[#1a2942] hover:text-[#f8f6f0] hover:border-[#a38e65] cursor-pointer whitespace-nowrap before:content-[''] before:absolute before:inset-1 before:border before:border-[#1a2942]/40 before:pointer-events-none before:transition-colors before:duration-300 hover:before:border-[#a38e65]/50";

const curriculum = [
  { n: '01', t: 'Professional Butler の振り返り', d: 'これまでの学習を総括し、Master Butler に求められる視座へと引き上げます。実務者から管理者・指導者への意識転換を図ります。' },
  { n: '02', t: '執事のリーダーシップ論', d: 'リーダーシップの本質、チームマネジメント、部下の育成と指導、モチベーション管理など、人を率いる力を学びます。' },
  { n: '03', t: 'ハウスホールド・マネジメント', d: '大規模邸宅の運営、スタッフ配置と管理、予算管理の基礎、外部業者との調整など、邸宅全体を統括する能力を習得します。' },
  { n: '04', t: '高度なVIP対応', d: '要人警護の基礎知識、セキュリティ意識、緊急時対応プロトコル、危機管理など、最高レベルのVIP対応を学びます。' },
  { n: '05', t: '国際プロトコル応用', d: '外交儀礼の詳細、国際行事での対応、文化的配慮の実践、多言語対応の基礎など、グローバルな場面での対応力を養います。' },
  { n: '06', t: '教育・指導の技法', d: '効果的な指導方法、OJTの実践、フィードバックの技術、評価とキャリア支援など、人を育てる技術を学びます。' },
  { n: '07', t: '執事サービスの品質管理', d: 'サービス品質の定義、標準化と個別対応のバランス、継続的改善の仕組み、顧客満足度の測定など、品質管理手法を習得します。' },
  { n: '08', t: '高度な問題解決能力', d: '複雑な状況への対応、優先順位の判断、多角的な視点、戦略的思考など、高度な問題解決力を養います。' },
  { n: '09', t: '執事ビジネスの経営知識', d: '執事サービスの事業モデル、収支管理の基本、契約と法的知識、マーケティングの考え方など、ビジネス視点を学びます。' },
  { n: '10', t: '高級ホテル・施設での執事業務', d: 'ホテルバトラーの役割、施設特有のオペレーション、他部署との連携、ブランド価値の維持など、組織での執事業務を理解します。' },
  { n: '11', t: 'プライベートバトラーの実務', d: '個人邸宅での業務、家族構成に応じた対応、長期的な信頼関係の構築、守秘義務の徹底など、プライベート執事の本質を学びます。' },
  { n: '12', t: '特殊なシチュエーション対応', d: '医療・介護との連携、特別なニーズへの対応、文化財・美術品の管理、ペットのケアなど、多様な状況への対応力を養います。' },
  { n: '13', t: '執事の倫理と哲学（上級編）', d: 'プロフェッショナルとしての矜持、倫理的ジレンマへの対応、執事の社会的責任、生涯学習の姿勢など、執事の精神性を深めます。' },
  { n: '14', t: '国際的な視野の醸成', d: '海外の執事文化やサービス動向の理解、グローバルスタンダードの学習、多様な文化背景を持つお客様への対応、情報収集の重要性など、国際的な視野を養います。' },
  { n: '15', t: 'Master Butler 総合演習', d: '高度なケーススタディ、マネジメントシミュレーション、指導実践演習、最終総合試験で、すべての学びを統合します。' },
];

const recommended = [
  'Professional Butler 資格を取得済みの方',
  '執事チームのリーダーを目指す方',
  '他の執事の教育・指導に携わりたい方',
  '大規模邸宅やホテルの管理者を目指す方',
  '執事サービス事業の経営に興味がある方',
  '執事としての最高峰を極めたい方',
  '国際的に活躍したい方',
];

const materials = [
  { t: 'テキスト教材（約300ページ）', d: '最も充実した内容の専用テキスト。マネジメント理論から実践まで、執事の最高峰に必要な知識を網羅しています。' },
  { t: 'オンライン動画レッスン', d: 'マネジメント事例を含む高度な内容。リーダーシップの実践、指導技法など、動画でしか伝えられない内容が満載です。視聴期間は1年間。' },
  { t: '実技練習用キット', d: '最上級の練習用グッズをお届けします。マネジメント演習に必要な教材も含まれています。' },
  { t: '認定試験問題・解答用紙', d: '最も高度な試験問題。ケーススタディや論述問題を含む、Master Butler にふさわしい内容です。' },
];

const examRows = [
  ['試験形式', '筆記試験（記述式・ケーススタディ・論述）'],
  ['合格基準', '80点以上'],
  ['試験期限', '申込から1年以内に提出'],
  ['受験資格', 'Professional Butler 資格保持者のみ'],
  ['受験場所', '自宅（通信試験）'],
  ['再試験', '不合格の場合、再試験料15,000円で何度でも再挑戦可能'],
];

const ladder = [
  { key: 'associate', roman: 'I', name: 'Associate Butler', ja: 'アソシエイト・バトラー', price: '48,000', level: '初級', href: '/qualifications/associate-butler' },
  { key: 'professional', roman: 'II', name: 'Professional Butler', ja: 'プロフェッショナル・バトラー', price: '78,000', level: '中級', href: '/qualifications/professional-butler' },
  { key: 'master', roman: 'III', name: 'Master Butler', ja: 'マスター・バトラー', price: '128,000', level: '上級', href: '/qualifications/master-butler' },
];

function SecHead({ roman, en, children }: { roman: string; en: string; children: React.ReactNode }) {
  return (
    <div className="mb-9">
      <div className="-mx-5 sm:-mx-8 mb-6 bg-[#1a2942] border-y border-[#a38e65]/25 px-5 sm:px-8 py-[18px]">
        <span className="block font-['Playfair_Display',serif] uppercase tracking-[0.28em] text-xs text-[#d7b779]">{roman}. {en}</span>
      </div>
      <h2 className="jba-display font-medium text-[#1a2942] text-2xl sm:text-3xl lg:text-[31px] leading-[1.5] tracking-[0.02em]">{children}</h2>
    </div>
  );
}

export default function MasterButlerPage() {
  useEffect(() => {
    updateSEO({
      title: 'Master Butler（マスター・バトラー）｜執事業界最高峰の上級資格 | 全日本執事協会',
      description: '全日本執事協会認定 Master Butler は、卓越した技術・知識に加え、指導と統括を担うマネジメント力を証明する最高位資格です。ハウスホールド・マネジメント、危機管理、教育・指導を全15章で習得。料金128,000円、Professional Butler 保持者が対象。執事サロン3時間無料体験付き。',
      keywords: 'Master Butler,マスター・バトラー,執事資格,上級資格,執事検定,マネジメント,指導,全日本執事協会',
      canonical: 'https://butler-association.jp/qualifications/master-butler',
    });
  }, []);

  const breadcrumbs = [
    { label: 'ホーム', href: '/' },
    { label: '執事資格制度', href: '/qualifications' },
    { label: 'Master Butler' },
  ];

  return (
    <Layout>
      <section className="relative bg-[#1a2942] overflow-hidden min-h-[540px] lg:min-h-[620px] flex items-center">
        <img
          src="/images/generated/jba-portrait-butler-01.webp"
          alt="正装の執事のポートレート"
          className="absolute inset-0 w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-[linear-gradient(90deg,rgba(16,20,26,0.93)_0%,rgba(16,20,26,0.74)_48%,rgba(16,20,26,0.36)_100%)]"></div>
        <div className="relative z-10 w-full max-w-[1200px] mx-auto px-5 sm:px-8 pt-32 pb-16 lg:pt-36 lg:pb-20">
          <div className="max-w-[680px]">
            <span className="block font-['Playfair_Display',serif] uppercase tracking-[0.32em] text-xs sm:text-[13px] text-[#d7b779] mb-4">Master Butler ・ Level III</span>
            <div className="w-12 h-px bg-[#a38e65] mb-6"></div>
            <h1 className="jba-display font-normal text-white text-[clamp(28px,3.4vw,44px)] leading-[1.4] tracking-[0.04em] mb-3">
              頂へ、<span className="text-[#d7b779]">Master Butler</span>
            </h1>
            <p className="font-['Noto_Serif_JP',serif] text-[#e7e2d8] text-sm tracking-[0.14em] mb-6">マスター・バトラー ／ 上級資格</p>
            <p className="font-['Noto_Serif_JP',serif] text-base sm:text-lg text-white/90 leading-[1.95] mb-8">
              執事業界における最高峰の資格です。卓越した技術と知識を有し、他の執事を指導し、複雑な状況をマネジメントできる能力を証明します。ハウスホールド・マネジメント、危機管理、国際プロトコル、教育・指導まで、統括者・指導者として必要な力を体系的に修めます。
            </p>
            <div className="flex flex-wrap items-end gap-x-8 gap-y-3">
              <div>
                <span className="block font-['Playfair_Display',serif] uppercase tracking-[0.2em] text-[10px] text-[#d7b779] mb-1">Fee</span>
                <span className="jba-display text-white text-[26px] sm:text-[28px] leading-none">128,000<span className="text-base text-[#d7b779] ml-1">円</span></span>
                <span className="block font-['Noto_Serif_JP',serif] text-[11px] text-white/60 mt-1">税込・送料込</span>
              </div>
              <a href="/contact" className={BTN08_ON_NAVY}>受講を申し込む</a>
            </div>
          </div>
        </div>
      </section>

      {/* パンくず: ビルボード直後に配置（Yuichi 2026-07-17 指摘②）。共通Breadcrumbのヘッダー逃げpaddingを子セレクタで通常paddingへ上書き */}
      <div className="bg-white [&>div]:!pt-6">
        <Breadcrumb items={breadcrumbs} />
      </div>

      <div className="bg-white">
        <div className="max-w-[1200px] mx-auto px-5 sm:px-8 py-14 sm:py-18 lg:py-20 space-y-16 sm:space-y-20">

          <section>
            <SecHead roman="I" en="About This Certification">導き、束ねる、<span className="text-[#a38e65]">統括の力</span></SecHead>
            <div className="space-y-[18px] font-['Noto_Serif_JP',serif] text-base text-[#333] leading-[1.95] max-w-3xl">
              <p>Master Butler 資格は、執事としての最高レベルの知識と技術、そしてリーダーシップとマネジメント能力を証明する最上位資格です。単なる実務スキルを超えて、チームを統率し、他の執事を育成し、組織全体のサービス品質を管理する能力を習得します。</p>
              <p>この資格では、ハウスホールド・マネジメント（大規模邸宅の運営）、高度なVIP対応と危機管理、国際プロトコルの深い理解、教育・指導の技法、執事サービスの品質管理など、マネジメント層として必要な幅広い知識を学びます。執事ビジネスの経営知識や、グローバルな視点での業界理解も含まれます。</p>
              <p>Professional Butler で培った実務能力を基盤に、より戦略的で包括的な視点を持つリーダーを育成します。取得後は、指導者・管理者としてのキャリアが拓かれます。</p>
            </div>
            <dl className="grid grid-cols-2 md:grid-cols-4 gap-y-6 gap-x-4 mt-10 border-t border-[#e2ddd2] pt-8">
              <div>
                <dt className="font-['Noto_Serif_JP',serif] text-xs text-[#8f7a56] tracking-[0.06em] mb-1.5">料金</dt>
                <dd className="jba-display text-[#1a2942] text-[26px] leading-none">128,000<span className="text-sm text-[#8f7a56] ml-1">円</span></dd>
              </div>
              <div>
                <dt className="font-['Noto_Serif_JP',serif] text-xs text-[#8f7a56] tracking-[0.06em] mb-1.5">テキスト</dt>
                <dd className="font-['Playfair_Display',serif] text-2xl text-[#1a2942]">約300<span className="text-sm text-[#8f7a56] ml-1">頁</span></dd>
              </div>
              <div>
                <dt className="font-['Noto_Serif_JP',serif] text-xs text-[#8f7a56] tracking-[0.06em] mb-1.5">学習期間目安</dt>
                <dd className="font-['Playfair_Display',serif] text-2xl text-[#1a2942]">6–8<span className="text-sm text-[#8f7a56] ml-1">ヶ月</span></dd>
              </div>
              <div>
                <dt className="font-['Noto_Serif_JP',serif] text-xs text-[#8f7a56] tracking-[0.06em] mb-1.5">受験資格</dt>
                <dd className="font-['Noto_Serif_JP',serif] text-base text-[#1a2942] leading-tight pt-1">Professional 保持者</dd>
              </div>
            </dl>
          </section>

          <section>
            <SecHead roman="II" en="Why Master">最高位が担う、<span className="text-[#a38e65]">三つの役割</span></SecHead>
            <div className="grid md:grid-cols-3 gap-x-10 gap-y-8">
              {[
                { no: '01', en: 'The Pinnacle', ja: '最高位の証', d: '執事業界における最上位の認定。卓越した専門性と信頼性を、確かなかたちで証明します。' },
                { no: '02', en: 'Management', ja: 'マネジメント', d: '大規模邸宅の統括、チームの管理、品質の維持。組織全体のサービスを束ねる力を養います。' },
                { no: '03', en: 'Mentoring', ja: '指導者育成', d: '他の執事を教え、導く。次世代を育てる指導力と、業界を牽引する視座を身につけます。' },
              ].map((f) => (
                <div key={f.no} className="border-t border-[#e2ddd2] pt-6">
                  <span className="font-['Playfair_Display',serif] text-[#d7b779] text-3xl leading-none block mb-3">{f.no}</span>
                  <span className="block font-['Playfair_Display',serif] italic text-[#8f7a56] text-[13px] tracking-[0.06em] mb-1">{f.en}</span>
                  <h3 className="jba-display font-medium text-[#1a2942] text-lg sm:text-xl mb-2.5 leading-[1.5]">{f.ja}</h3>
                  <p className="font-['Noto_Serif_JP',serif] text-sm text-[#4a4638] leading-[1.9]">{f.d}</p>
                </div>
              ))}
            </div>
          </section>

          <section>
            <SecHead roman="III" en="Curriculum ・ 15 Chapters">全15章で修める、<span className="text-[#a38e65]">統括の知</span></SecHead>
            <p className="font-['Noto_Serif_JP',serif] text-base text-[#333] leading-[1.95] max-w-3xl mb-8">
              Master Butler では、執事のリーダーとして必要な15の分野を深く学びます。実務スキルからマネジメント、経営知識まで、資格制度のなかで最も包括的な内容です。
            </p>
            <img
              src="/images/generated/jba-fs-167-qualifications_master-butler.webp"
              alt="Master Butler の学習教材。マネジメントと指導の理論を収めたテキスト"
              className="w-full aspect-[21/9] h-auto object-cover object-center border border-[#a38e65]/30 mb-10"
            />
            <div className="grid md:grid-cols-2 gap-x-10 gap-y-8">
              {curriculum.map((c) => (
                <div key={c.n} className="flex gap-5 border-t border-[#e2ddd2] pt-6">
                  <span className="font-['Playfair_Display',serif] text-[#d7b779] text-3xl leading-none shrink-0 pt-1">{c.n}</span>
                  <div>
                    <h3 className="jba-display font-medium text-[#1a2942] text-lg mb-2.5 leading-[1.5]">{c.t}</h3>
                    <p className="font-['Noto_Serif_JP',serif] text-sm text-[#4a4638] leading-[1.9]">{c.d}</p>
                  </div>
                </div>
              ))}
            </div>
          </section>

          {/* IV. こんなかたに（細罫2カラムリスト型）= 新バリエーション①。由来注記: overview S2 定義リストdl文法を翻案 */}
          <section>
            <SecHead roman="IV" en="Recommended For">こんなかたに、<span className="text-[#a38e65]">おすすめです</span></SecHead>
            <ul className="grid sm:grid-cols-2 gap-x-10 border-t-2 border-[#1a2942]">
              {recommended.map((r) => (
                <li key={r} className="flex items-start gap-3 border-b border-[#e2ddd2] py-4">
                  <span className="text-[#a38e65] text-[13px] leading-none pt-1.5" aria-hidden="true">◆</span>
                  <span className="font-['Noto_Serif_JP',serif] text-[15px] text-[#1a2942] leading-[1.8]">{r}</span>
                </li>
              ))}
            </ul>
          </section>

          {/* V. 教材（積層splitカード型）= 新バリエーション②。由来注記: カタログ SEC-N04 積層カード文法 */}
          <section>
            <SecHead roman="V" en="Course Materials">お手元に届く、<span className="text-[#a38e65]">最上級の一式</span></SecHead>
            <div className="grid md:grid-cols-2 gap-6">
              {materials.map((m, i) => (
                <div key={m.t} className="flex gap-5 bg-[#f8f6f0] border border-[#a38e65]/25 p-6">
                  <span className="font-['Playfair_Display',serif] text-[#a38e65] text-2xl leading-none shrink-0 pt-0.5">{String(i + 1).padStart(2, '0')}</span>
                  <div>
                    <h3 className="jba-display font-medium text-[#1a2942] text-base sm:text-lg mb-2 leading-[1.5]">{m.t}</h3>
                    <p className="font-['Noto_Serif_JP',serif] text-sm text-[#4a4638] leading-[1.9]">{m.d}</p>
                  </div>
                </div>
              ))}
            </div>
            <div className="mt-6 bg-[#1a2942] px-7 sm:px-10 py-7 flex flex-col sm:flex-row sm:items-center gap-4 sm:gap-7">
              <span className="font-['Playfair_Display',serif] italic text-[#d7b779] text-sm tracking-[0.06em] shrink-0">Special Bonus</span>
              <div>
                <h3 className="jba-display font-medium text-[#f8f6f0] text-lg mb-1">執事サロン3時間 無料体験チケット</h3>
                <p className="font-['Noto_Serif_JP',serif] text-sm text-[#ded8cc] leading-[1.9]">お台場の執事サロンで、実際の執事サービスを体験できる特別チケット（30,000円相当）。Master レベルの学びをいっそう深められます。</p>
              </div>
            </div>
          </section>

          <section>
            <SecHead roman="VI" en="Certification Exam">試験は、<span className="text-[#a38e65]">ご自宅で</span>受けられます</SecHead>
            <div className="grid lg:grid-cols-[1fr_320px] gap-8 lg:gap-12 items-start">
              <dl className="border-t-2 border-[#1a2942]">
                {examRows.map(([label, value]) => (
                  <div key={label} className="flex flex-col sm:flex-row gap-1 sm:gap-6 border-b border-[#e2ddd2] py-4">
                    <dt className="sm:w-[110px] sm:shrink-0 font-['Noto_Serif_JP',serif] text-sm text-[#8f7a56] tracking-[0.06em] pt-0.5">{label}</dt>
                    <dd className="flex-1 font-['Noto_Serif_JP',serif] text-[15px] sm:text-base text-[#1a2942] leading-[1.85]">{value}</dd>
                  </div>
                ))}
              </dl>
              <div className="lg:pt-1">
                <img
                  src="/images/generated/jba-p-023-qual-master.webp"
                  alt="最上級の統括研修。指導実践を学ぶ Master Butler の学び"
                  className="w-full h-56 lg:h-[300px] object-cover border border-[#a38e65]/30 mb-4"
                />
                <p className="font-['Noto_Serif_JP',serif] text-sm text-[#4a4638] leading-[1.9]">
                  受験には Professional Butler 資格の保持が必要です。ケーススタディと論述を含む筆記試験を自宅で受け、80点以上で合格。執事としての哲学や指導方針まで、リーダーの資質を総合的に評価します。
                </p>
              </div>
            </div>
          </section>

          {/* VII. 三段階の階梯（現在地=master）= 新バリエーション③。由来注記: overview S5 タイムライン文法を資格ステッパーへ翻案 */}
          <section>
            <SecHead roman="VII" en="The Three Tiers">資格は、<span className="text-[#a38e65]">三段階</span>で高めていく</SecHead>
            <p className="font-['Noto_Serif_JP',serif] text-base text-[#333] leading-[1.95] max-w-3xl mb-8">
              執事資格は、初級 Associate Butler から、中級 Professional Butler、上級 Master Butler へと段階的に取得します。飛び級での受験はできません。Master Butler は、その頂点に立つ最高位資格です。
            </p>
            <ol className="border-t border-[#e2ddd2]">
              {ladder.map((t) => {
                const current = t.key === 'master';
                return (
                  <li key={t.key} className={current ? 'bg-[#1a2942] border-b border-[#e2ddd2]' : 'border-b border-[#e2ddd2]'}>
                    <a href={t.href} className={`flex flex-wrap items-center gap-x-6 gap-y-2 px-5 sm:px-7 py-5 group ${current ? '' : 'hover:bg-[#f8f6f0]'} transition-colors duration-300`}>
                      <span className={`font-['Playfair_Display',serif] text-2xl w-8 shrink-0 ${current ? 'text-[#d7b779]' : 'text-[#a38e65]'}`}>{t.roman}</span>
                      <div className="min-w-[210px]">
                        <span className={`block jba-display text-lg ${current ? 'text-[#f8f6f0]' : 'text-[#1a2942]'}`}>{t.name}{current && <span className="ml-3 align-middle text-[10px] font-['Noto_Serif_JP',serif] tracking-[0.14em] text-[#1a2942] bg-[#d7b779] px-2 py-0.5">現在ご覧のページ</span>}</span>
                        <span className={`block font-['Noto_Serif_JP',serif] text-xs mt-0.5 ${current ? 'text-[#c9c2b4]' : 'text-[#8f7a56]'}`}>{t.ja}・{t.level}</span>
                      </div>
                      <span className={`jba-display text-xl ml-auto ${current ? 'text-[#d7b779]' : 'text-[#1a2942]'}`}>{t.price}<span className={`text-xs ml-1 ${current ? 'text-[#c9c2b4]' : 'text-[#8f7a56]'}`}>円</span></span>
                      <span className={`font-['Noto_Serif_JP',serif] text-sm shrink-0 ${current ? 'text-[#d7b779]' : 'text-[#a38e65] group-hover:translate-x-1 transition-transform'}`}>{current ? '—' : '詳細を見る →'}</span>
                    </a>
                  </li>
                );
              })}
            </ol>
          </section>

          <section>
            <SecHead roman="VIII" en="Enrollment">受講のご案内</SecHead>
            <div className="bg-[#1a2942] border border-[#a38e65]/45 p-8 sm:p-10 lg:p-12">
              <div className="flex flex-wrap items-end gap-x-8 gap-y-3 mb-8 pb-8 border-b border-white/15">
                <div>
                  <span className="block font-['Playfair_Display',serif] uppercase tracking-[0.2em] text-[11px] text-[#d7b779] mb-1.5">Master Butler ・ Fee</span>
                  <span className="jba-display text-white text-[34px] sm:text-[40px] leading-none">128,000<span className="text-lg text-[#d7b779] ml-1.5">円</span></span>
                  <span className="block font-['Noto_Serif_JP',serif] text-xs text-white/60 mt-1.5">税込・送料込 ／ 資格の有効期限なし</span>
                </div>
                <ul className="grid sm:grid-cols-2 gap-x-8 gap-y-1.5 flex-1 min-w-[260px]">
                  {['テキスト教材（約300ページ）', 'オンライン動画レッスン（1年間）', '実技練習用キット', '認定試験問題・解答用紙', '試験添削サービス', '認定証・認定カード', '執事サロン3時間無料体験', '送料'].map((x) => (
                    <li key={x} className="flex items-start gap-2 font-['Noto_Serif_JP',serif] text-[13px] text-[#e7e2d8] leading-[1.7]">
                      <span className="text-[#d7b779] text-[11px] pt-1" aria-hidden="true">◆</span>{x}
                    </li>
                  ))}
                </ul>
              </div>
              <p className="font-['Noto_Serif_JP',serif] text-base text-[#e7e2d8] leading-[1.95] max-w-3xl mb-8">
                執事業界の最高峰を目指すかたのための、特別なプログラムです。Master Butler として、業界をリードする人材を目指してください。ご不明な点は、お気軽にお問い合わせください。
              </p>
              <div className="flex flex-col sm:flex-row gap-4 sm:gap-6">
                <a href="/contact" className={BTN08_ON_NAVY}>受講を申し込む・相談する</a>
                <a href="/qualifications" className={BTN08_ON_NAVY}>資格制度の一覧に戻る</a>
              </div>
            </div>
            <p className="font-['Noto_Serif_JP',serif] text-xs text-[#8f7a56] leading-[1.9] mt-6 max-w-3xl">
              本資格は全日本執事協会が認定する民間資格です。受験には Professional Butler 資格の保持が必須です。資格取得により就職・転職・収入を保証するものではなく、知識習得と自己研鑽を目的とした学習プログラムです。
            </p>
          </section>

        </div>
      </div>
    </Layout>
  );
}
